export default function HighlightedText({ text, searchQuery }: { text: string; searchQuery: string }) {
  if (!searchQuery.trim() || !text) return text

  const escapedSearch = searchQuery.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
  const regex = new RegExp(`(${escapedSearch})`, "gi")
  const parts = text.split(regex)

  return parts.map((part, i) =>
    regex.test(part) ? (
      <mark key={i} className="text-yellow-foreground bg-yellow-background rounded-sm">
        {part}
      </mark>
    ) : (
      part
    )
  )
}
